import Media from './media';

export class PdpProductDescription {
  numberOfStars: number;
  productTitle: string;
  rating: string;
  reviews: string;
  starIcon: Media | undefined;

  constructor(props: any) {
    this.productTitle = props.productTitle;
    this.numberOfStars = props.numberOfStars;
    this.rating = props.rating;
    this.reviews = props.reviews;
    this.starIcon = props.starIcon ? new Media(props.starIcon) : undefined;
  }
}

export default PdpProductDescription;
